import { useStoreAuthenticationInfo } from '../common/correlation-info-store';
import { useAdminLogin } from '../useAdminLogin';

export function SetupGlobals() {
  useStoreAuthenticationInfo();
  useAdminLogin();
  return null;
}
